import {STATE_PROP_NAME} from './industry-report-constants'

export const getState = state => state[STATE_PROP_NAME]
export const getIndustryId = state => getState(state).industryId
export const getTimeFrameDays = state => getState(state).timeFrameDays
export const getGeography = state => getState(state).selectedGeography
